<template>
    <div>
      <pdf
        ref="pdf"
        v-for="i in numPages" 
        :key="i"  
        :src="url" 
        :page="i"
      ></pdf>
    </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
  components:{ pdf },
  created(){
      let query = this.$route.query
      this.url = query.pdfUrl
  },
  mounted() {
      this.getNumPages()
  },
  data(){
      return {
          url: undefined,
          numPages: null, // pdf 总页数
      }
  },
  methods: {
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.url)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
  }
}
</script>